import { currencyRangeColumn, dateRangeColumn } from '../utils/column-helpers';

export const kCode = {
  Header: 'KCode',
  accessor: 'kCode',
};

export const merchantName = {
  Header: 'Merchant Name',
  accessor: 'merchantName',
};

export const supplierName = {
  Header: 'Supplier Name',
  accessor: 'supplierName',
};

export const brandName = {
  Header: 'Brand Name',
  accessor: 'brandName',
};

export const brandCode = {
  Header: 'Brand Code',
  accessor: 'brandCode',
};

export const merchantId = {
  Header: 'Merchant ID',
  accessor: 'merchantId',
};

export const merchantCountries = {
  Header: 'Merchant Countries',
  accessor: 'merchantCountries',
  Cell: row => (row.value ? row.value.join(', ') : null),
};

export const supplierCountryName = {
  Header: 'Supplier Country',
  accessor: 'supplierCountryName',
};

export const dwhModifiedDate = dateRangeColumn(
  'Modified Date',
  'dwhModifiedDate',
  100,
);

export const dwhCreateDate = dateRangeColumn(
  'Created Date',
  'dwhCreateDate',
  100,
);

export const gmv = currencyRangeColumn({
  Header: 'GMV',
  accessor: 'gmv',
  id: 'gmv',
  hasPrefix: false,
  sortable: false,
});

export const listColumns = [
  kCode,
  merchantName,
  supplierName,
  brandName,
  brandCode,
  gmv,
  merchantId,
  merchantCountries,
  supplierCountryName,
  dwhModifiedDate,
  dwhCreateDate,
];
